const meta = {
  datasets: 'Datasets',
  budgeting: 'Budgets',
};

export default meta;
